export function luhnCheck(digits) {
  let sum = 0;
  let shouldDouble = false;

  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = parseInt(digits[i], 10);
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
}

export function isCreditCardValid(value) {
  const digits = String(value).replace(/\D/g, '');
  if (digits.length < 13 || digits.length > 19) return false;
  return luhnCheck(digits);
}

export function isCardCvvValid(value) {
  return /^\d{3,4}$/.test(String(value).replace(/\s/g, ''));
}

export function initCardNumberInput(input) {
  if (!input || input.dataset.cardNumberValidator === 'true') return;

  input.setAttribute('inputmode', 'numeric');
  input.setAttribute('autocomplete', 'cc-number');

  input.addEventListener('blur', () => {
    const form = input.closest('form');
    const validator = form?.formTheme?.validator;
    if (!validator) return;

    validator.activated.add(input);
    validator.validate(input);
  });

  input.dataset.cardNumberValidator = 'true';
}

export function initCardCvcInput(input) {
  if (!input || input.dataset.cardCvcValidator === 'true') return;

  input.setAttribute('inputmode', 'numeric');
  input.setAttribute('autocomplete', 'cc-csc');
  input.setAttribute('maxlength', '4');

  input.addEventListener('input', () => {
    input.value = input.value.replace(/\D/g, '').slice(0, 4);
  });

  input.addEventListener('blur', () => {
    const form = input.closest('form');
    const validator = form?.formTheme?.validator;
    if (!validator) return;

    validator.activated.add(input);
    validator.validate(input);
  });

  input.dataset.cardCvcValidator = 'true';
}
